import {parseDate} from "../../../../util/dateTools.ts";
import IFilterService = angular.IFilterService;
import {UrlService} from "../../../../services/urlService";

class LinesController {
    searchResult;
    title="Linjer";
    defaultSearchParams = {pageSize:100, pageNo: 0, sort:""};
    activeSearchParams = {pageSize:100, pageNo: 0, sort:""};

    //--- Searchform-definition ------------------------------------------------
    searchDefinition ={
        fields:[
            {title:'Ordredato', name: 'orderDate', type:'date'},
            {title:'Bekreftet dato', name: 'confirmedDate', type:'date'},
            {title:'Ordrenr.', name: 'orderNo', type:'number'},
            {title:'Kunde', name: 'customerNameOrId', type:'text'},
            {title:'Kundegruppe', name: 'customerGroupNo', type:'text'},
            {title:'Vare', name: 'articleNameOrId', type:'text'},
            {title:'Varegruppe', name: 'articleGroup', type:'text'},
            {title:'Bekreftet', name: 'noConfirmed', type:'number'}
        ],
        searchFunction:(paramsWithFormattedDates)=> this.linesSearch(paramsWithFormattedDates),
        searchParams: Object.assign({},this.defaultSearchParams),
        preDefinedSearches : [
            {title: "Ubekreftede ordre", ligature: "drafts", func:()=>this.getUnconfirmedLines(), name:'unconfirmedLines'},
            {title: "Avvik", ligature: "call_missed", func:()=>this.getAbberationLines(), name:'abberationLines'},
        ]
    };

    //--- Toolbarheader-definition ------------------------------------------------
    toolbarheaderDefinition = {
        isTable: true,
        toolbarHeading: "Linjeoversikt",
        buttons: [
            {func: () => { this.searchDefinition.searchParams = Object.assign({},this.defaultSearchParams)},   tooltip: "Slett søkedata",    materialicon: "delete_sweep"},
        ],
    };

    //--- Table-definition ---------------------------------------------------
    iconColumn = {title:'', name: ''};
    // TODO To be sorted: articleNoAndName, requestedDeliveryDate  (remove noOrderBy)
    tableDefinition = {
        settings:{
            onPaginate: (pageInfo)=> this.changePage(pageInfo),
            onOrderBy: (columnName)=> this.orderBy(columnName),
            totalElements:null,
            promise: null
        },
        columns: [
            this.iconColumn,
            this.iconColumn,
            {title: 'Ordre', name: 'orderNo', type: 'text'},
            {title: 'Kunde', name: 'customerNoAndName', type: 'text'},
            this.iconColumn,
            {title: 'Vare', name: 'articleNoAndName', type: 'text'},
            {title: 'Ønsket levering', name: 'requestedDeliveryDate', type: 'text'},
            {title: 'I Ordre', name: 'quantity', type:'text', noOrderBy:true},
            {title: 'Behov', name: 'quantityNeeded', type:'text' , noOrderBy:true},
            this.iconColumn,
            {title: 'Tilgjengelig', name: 'availableDate', type: 'text', noOrderBy:true},
            this.iconColumn,
            {title: 'Bekr. Dato', name: 'deliveryDate', type: 'text'},
            {title: 'Splittet', name:'', noOrderBy:true},
        ]
    };
    //--- Constructor -------------------------------------------------
    constructor( private urlService: UrlService, private OrderLines, private toastService, private $location: ILocationService) {}

    changePage(pageInfo){
        this.activeSearchParams.pageNo = pageInfo.page -1;
        this.activeSearchParams.pageSize = pageInfo.limit;
        this.$location.search(this.activeSearchParams);
    }

    orderBy(columnName){
        var descending = columnName[0] === '-';
        columnName = descending ? columnName.slice(1, columnName.length) : columnName;
        var orderDirection = descending ? "desc" : "asc";
        columnName = columnName === 'articleNoAndName' ? 'articleNo|' + orderDirection + ',name' : columnName;

        this.activeSearchParams.sort = columnName + "|" + orderDirection;
        this.$location.search(this.activeSearchParams);
    }

    linesSearch(paramsWithFormattedDates){
        this.activeSearchParams = paramsWithFormattedDates;
        this.tableDefinition.settings.promise = this.OrderLines.search(paramsWithFormattedDates, {}).$promise.then(
            (results)=> this.processResults(results),
            (error)=> this.processError(error)
        );
    }
    getAbberationLines(){
        this.activeSearchParams = this.searchDefinition.searchParams;
        this.tableDefinition.settings.promise = this.OrderLines.getAbberations(this.searchDefinition.searchParams).$promise.then(
            (results)=> this.processResults(results),
            (error)=> this.processError(error)
        );
    }
    getUnconfirmedLines(){
        this.activeSearchParams = this.searchDefinition.searchParams;
        this.tableDefinition.settings.promise = this.OrderLines.getUnconfirmed(this.searchDefinition.searchParams).$promise.then(
            (results)=> this.processResults(results),
            (error)=> this.processError(error)
        );
    }
    processResults(results){
        if(results.content.length === 0){
            this.toastService.showSimpleToast("Søket gav ingen resultater", 2000);
            this.searchResult = null;
        }
        else{
            this.tableDefinition.settings.totalElements = results.totalElements;
            this.searchResult = results.content.map(line => {
                line.quantityNeeded = line.available < 0 ? line.available * -1 : 0;
                line.deliveryDate = line.deliveryDate ? new Date(line.deliveryDate): null;
                line.routeDaysString = line.routeDays.toString();
                return line;
            });
        }
    }
    processError(error){
        this.toastService.parseError(error);
        this.searchResult = null;
    }
}

class LinesOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcLinesController";
    public template: any = require('./lines.html');
}

rkcApp.controller("rkcLinesController", ['urlService','OrderLines', 'toastService','$location',function(urlService, OrderLines, toastService, $location){
    return new LinesController(urlService, OrderLines, toastService, $location);
}])
    .component("rkcLines", new LinesOptions())
;


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/lines/lines.ts
 **/